import React, { useState, useEffect } from 'react';
import { Autocomplete, IconButton, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useSelector } from 'react-redux';

import { useInsightAnzsicCodeSearchQuery } from '@/features/properties/propertiesApi';
import { useGetUserDetailsQuery } from '@/features/user/userApi';

//Because form takes an object
const extractCode = (value) => {
	if (!value) return '';

	if (typeof value === 'object') {
		return value.Code ?? '';
	}
	if (typeof value === 'string') {
		const match = value.match(/\d{4}/);
		return match ? match[0] : '';
	}
	return '';
};

export const AnzsicCodeSearch = ({ onSelect, disabled = false, initialValue = '' }) => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });

	const extractedCode = extractCode(initialValue);

	const [selectedValue, setSelectedValue] = useState(null);
	const [searchQuery, setSearchQuery] = useState(extractedCode);
	const [options, setOptions] = useState([]);

	const { data, isLoading, isFetching } = useInsightAnzsicCodeSearchQuery(
		{
			searchQuery,
		},
		{
			skip: !searchQuery || searchQuery.length < 3 || !userDetails?.userId,
		},
	);

	useEffect(() => {
		if (data?.Results) {
			setOptions(data.Results);
		}
	}, [data]);
	useEffect(() => {
		if (!extractedCode || !options.length) return;

		const match = options.find((option) => option.Code === extractedCode);

		if (match) {
			setSelectedValue(match);
		}
	}, [extractedCode, options]);

	useEffect(() => {
		if (initialValue) {
			setSearchQuery(extractedCode);
		}
	}, [initialValue, extractedCode]);

	return (
		<Autocomplete
			options={options}
			value={selectedValue}
			autoComplete
			disabled={disabled}
			loading={isLoading || isFetching}
			getOptionLabel={(option) => option?.Name ?? ''}
			isOptionEqualToValue={(option, value) => option?.Id === value?.Id}
			onChange={(event, value) => {
				setSelectedValue(value);

				onSelect(value ?? null);
			}}
			onInputChange={(event, newValue) => {
				setSearchQuery(newValue ?? '');
			}}
			noOptionsText={
				searchQuery.length < 3
					? 'Type to search'
					: isLoading || isFetching
						? 'Searching...'
						: 'No options'
			}
			renderInput={(params) => (
				<TextField
					{...params}
					variant='outlined'
					fullWidth
					InputProps={{
						...params.InputProps,
						startAdornment: (
							<InputAdornment position='start'>
								<IconButton sx={{ padding: 0 }}>
									<SearchIcon />
								</IconButton>
							</InputAdornment>
						),
					}}
				/>
			)}
		/>
	);
};
